import { CommonTableColumnsEnum } from '../../components/Table/types'
import { CASH_FLOWS_PATH } from '../../constants'
import AbstractService from '../../services/AbstractService'
import { ServerResponse } from '../../types'

import {
  CashFlowBalanceRequestType,
  CashFlowData,
  CashFlowEntry,
  CashFlowRequestType,
  CashFlowStatsRequestType,
  CashFlowStatsResponseType,
  RawCashFlowEntry,
} from './types'

class CashFlowServiceClass extends AbstractService {
  getCashFlows = async (data: CashFlowRequestType) => {
    const response = await this.request<ServerResponse<CashFlowData>>(
      CASH_FLOWS_PATH,
      'post',
      true,
      data,
    )

    return {
      ...response,
      data: {
        ...response.data,
        data: response.data.data.map(this.mapCashFlowEntry),
      },
    }
  }

  getCashFlowBalance = (data: CashFlowBalanceRequestType) =>
    this.request<ServerResponse<{ balance: number }>>(
      `${CASH_FLOWS_PATH}/balance`,
      'post',
      true,
      data,
    )

  getCashFlowStats = (data: CashFlowStatsRequestType) =>
    this.request<ServerResponse<CashFlowStatsResponseType>>(
      `${CASH_FLOWS_PATH}/stats`,
      'post',
      true,
      data,
    )

  private mapCashFlowEntry = (entry: RawCashFlowEntry): CashFlowEntry => ({
    [CommonTableColumnsEnum.id]: Number(entry.id),
    [CommonTableColumnsEnum.amount]: Number(entry.amount ?? 0),
    [CommonTableColumnsEnum.cashFlowType]: entry.cashFlowType || entry.type || 'unknown',
    [CommonTableColumnsEnum.comment]:
      typeof entry.comment === 'string' && entry.comment.trim().length
        ? entry.comment.trim()
        : null,
    [CommonTableColumnsEnum.date]: entry.date,
  })
}

export const CashFlowService = new CashFlowServiceClass()
